export const resizeIFrameToFitContent = ({ target: iFrame, breakpoint }) => {
  const iFrameBodyMargin = parseInt(
    window.getComputedStyle(iFrame.contentWindow.document.body).margin,
    10,
  );
  const iFrameScrollWidth = iFrame.contentWindow.document.body.scrollWidth;
  const iFrameScrollHeight = iFrame.contentWindow.document.body.scrollHeight;
  const requiredWidth = iFrameScrollWidth + iFrameBodyMargin * 2;
  const requiredHeight = iFrameScrollHeight + iFrameBodyMargin * 2;
  const parent = iFrame.parentElement;
  const parentWidthWithScrollbar = iFrame.parentElement.clientWidth;
  const scale =
    parentWidthWithScrollbar < requiredWidth
      ? parentWidthWithScrollbar / requiredWidth
      : 1;

  const marginLeft =
    requiredWidth * scale < parentWidthWithScrollbar
      ? `${(parentWidthWithScrollbar - requiredWidth * scale) / 2}px`
      : '0';

  iFrame.width = requiredWidth;
  iFrame.height = requiredHeight;
  iFrame.style.transform = `scale(${scale})`;
  iFrame.style.transformOrigin = '0 0';
  // The content is scaled but the iframe height remains the same so we
  // add a negative margin to avoid an empty space at the bottom
  iFrame.style.marginBottom = `-${requiredHeight - requiredHeight * scale}px`;
  iFrame.style.marginRight = `-${requiredWidth - requiredWidth * scale}px`;
  iFrame.style.marginLeft = marginLeft;
  parent.style.overflow = ['s', 'm'].includes(breakpoint) ? 'hidden' : 'auto';
};
